(function () {
  Flint.file('mframework/views/scrollable.js', function (require) {
    Flint.staticStyles('Scrollable', {
      '$': '#_flintapp .ViewScrollable',
      '$container': '#_flintapp container.Scrollable, #_flintapp .Scrollable.container, #_flintapp .ViewScrollable.container, #_flintapp .Scrollable > .container',
      '$scrollable': '#_flintapp scrollable.Scrollable, #_flintapp .Scrollable.scrollable, #_flintapp .ViewScrollable.scrollable, #_flintapp .Scrollable > .scrollable',
      '$scrollContent': '#_flintapp scrollContent.Scrollable, #_flintapp .Scrollable.scrollContent, #_flintapp .ViewScrollable.scrollContent, #_flintapp .Scrollable > .scrollContent',
      '$topShadow': '#_flintapp topShadow.Scrollable, #_flintapp .Scrollable.topShadow, #_flintapp .ViewScrollable.topShadow, #_flintapp .Scrollable > .topShadow',
      '$bottomShadow': '#_flintapp bottomShadow.Scrollable, #_flintapp .Scrollable.bottomShadow, #_flintapp .ViewScrollable.bottomShadow, #_flintapp .Scrollable > .bottomShadow'
    }, {
      '$': {
        overflow: 'auto',
        alignItems: 'stretch',
        position: 'relative'
      },
      '$container': {
        overflow: 'auto',
        flexGrow: 1,
        alignItems: 'stretch'
      },
      '$scrollable': {
        overflow: 'auto',
        alignItems: 'stretch',
        flexGrow: 1
      },
      '$scrollContent': {
        flexGrow: 1,
        alignItems: 'stretch'
      },
      '$topShadow': {
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: 2,
        top: 0,

        left: 0,
        right: 0,
        height: 3,
        background: 'linear-gradient(to bottom, rgba(150, 150, 150, 0.8) 0%, rgba(150, 150, 150, 0) 100%)'
      },
      '$bottomShadow': {
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: 2,
        bottom: 0,

        left: 0,
        right: 0,
        height: 3,
        background: 'linear-gradient(to bottom, rgba(150, 150, 150, 0) 0%, rgba(150, 150, 150, 0.8) 100%)'
      }
    });
    Flint.view('Scrollable', function (view, on, $) {
      var pro = initPro(view, {
        autoBottom: M.defaultAtom(false),
        children: atom()
      });

      var elem = atom();
      var offsetHeight = atom();
      var scrollHeight = atom();
      var scrollTop = atom(0);

      var scrollHeightAfterAuto = atom();
      var scrollTopAfterAuto = atom();

      var atTop = derivation(function () {
        return scrollTop.get() == 0;
      });

      var atBottom = derivation(function () {
        if (elem.get() && offsetHeight.get()) {
          return scrollTop.get() >= scrollHeight.get() - offsetHeight.get();
        } else {
          return false;
        }
      });

      scrollHeight.react(function (scrollHeight) {
        if (elem.get() && pro.autoBottom.get() && (scrollHeightAfterAuto.get() == undefined || scrollHeight > scrollHeightAfterAuto.get() && scrollTop.get() >= scrollTopAfterAuto.get() - 5)) {
          elem.get().scrollTop = elem.get().scrollHeight;
          transact(function () {
            scrollHeightAfterAuto.set(elem.get().scrollHeight);
            scrollTopAfterAuto.set(elem.get().scrollTop);
          });
        }
      });

      on.change(function () {
        on.delay(1, function () {
          if (elem.get()) {
            transact(function () {
              scrollHeight.set(elem.get().scrollHeight);
              offsetHeight.set(elem.get().offsetHeight);
            });
          }
        });
      });view.render(function () {
        return view.el(
          ['scrollable', 1],
          {
            ref: function (el) {
              return elem.set(el);
            },
            onScroll: function (e) {
              scrollTop.set(e.target.scrollTop);
            }
          },
          view.el(
            ['scrollContent', 1],
            null,
            pro.children.get()
          )
        );
      });view.render(function () {
        return view.el(['topShadow', 1], null);
      });view.render(function () {
        return view.el(['bottomShadow', 1], null);
      });

      $["topShadow"] = function (_, _index) {
        return { visibility: atTop.get() ? 'hidden' : 'visible' };
      };

      $["bottomShadow"] = function (_, _index) {
        return { visibility: atBottom.get() ? 'hidden' : 'visible' };
      };
    });
  })
})();
//# sourceMappingURL=scrollable.js.map
